import agent from "src/api/agent";




export const getCustomer = (usr) => agent.requests.post(`/Web/getCustomerInformations`,usr);


export const postUpdateCustomer = (cust) => {

    return agent.requests.post(`/Admin/callcenterupdatecustomer`, cust);
}
